import IncButton from 'components/inc-button/inc-button.component';
import styled from 'styled-components';

export const SubmitButton = styled(IncButton)`
  margin: 0.5em !important;
`;
